import type { ProviderMode } from "./ai-assistant-provider-mode";

/**
 * Pindah otomatis ke profil Cadangan (v2/M2). Sakelar bawaan MATI; saat nyala,
 * giliran chat yang gagal karena gangguan/kuota/kunci ditolak dijawab profil
 * lawan dari Utama. Kontrak ini dipakai server dan kartu "Mode penyedia".
 */

/** Alasan failover yang butuh tindakan admin (kuota/saldo habis, kunci ditolak). */
export const FAILOVER_ALERT_REASONS = [
	"quota_exhausted",
	"auth_rejected",
] as const;
export type FailoverAlertReason = (typeof FAILOVER_ALERT_REASONS)[number];

export interface FailoverAlertDto {
	at: string;
	/** Slot profil yang bermasalah (chat | chat_backup). */
	slot: string;
	reason: FailoverAlertReason;
}

export interface FailoverStatusDto {
	enabled: boolean;
	/** Per mode: profil Cadangannya (lawan Utama) lengkap & kuncinya terbaca. */
	backupReady: Record<ProviderMode, boolean>;
	/** Kejadian terbaru yang butuh tindakan admin (7 hari terakhir). */
	recentAlerts: FailoverAlertDto[];
	/** Profil yang sedang dilewati pemutus sirkuit — hanya di instance server yang menjawab (hilang saat restart). */
	openProfiles: { slot: string; openUntil: string }[];
}

export interface FailoverUpdate {
	enabled: boolean;
}

export const FAILOVER_MESSAGES = {
	needOpenAiBackup:
		"Lengkapi kunci OpenAI dulu (kartu Chat cadangan) sebelum menyalakan pindah otomatis.",
	needClaudeBackup:
		"Lengkapi kunci Claude dulu (kartu Chat) sebelum menyalakan pindah otomatis.",
	cryptoMissing:
		"AI_CREDENTIALS_KEY belum diset di server — kunci tidak bisa dibaca.",
} as const;

/** Pesan penolakan menyalakan failover untuk mode ini (null bila boleh). Dipakai server dan UI. */
export function failoverBlockedReason(
	status: Pick<FailoverStatusDto, "backupReady">,
	mode: ProviderMode,
	cryptoConfigured: boolean,
): string | null {
	if (!cryptoConfigured) return FAILOVER_MESSAGES.cryptoMissing;
	if (status.backupReady[mode]) return null;
	return mode === "chatgpt_only"
		? FAILOVER_MESSAGES.needClaudeBackup
		: FAILOVER_MESSAGES.needOpenAiBackup;
}
